import { useState } from "react";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { GALLERY } from "../lib/data";
import { Reveal, SectionHeading } from "../components/Reveal";

export default function GalleryPage() {
  const [active, setActive] = useState(null);

  return (
    <section className="wrap py-16 sm:py-24">
      <SectionHeading
        eyebrow="Galeri"
        title="Galeri Kegiatan"
        description="Dokumentasi armada dan aktivitas operasional Putra Bengawan Logistik."
      />
      <div className="mt-12 columns-2 gap-4 lg:columns-3 [&>*]:mb-4">
        {GALLERY.map((g, i) => (
          <Reveal key={g.id} delay={0.04 * (i % 3)} className="break-inside-avoid">
            <button
              data-testid={`galeri-item-${i}`}
              onClick={() => setActive(g)}
              className="group relative block w-full overflow-hidden rounded-2xl border border-zinc-800"
            >
              <img
                src={g.foto}
                alt={g.judul}
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent p-4 pt-10 text-left text-sm text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                {g.judul}
              </span>
            </button>
          </Reveal>
        ))}
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl border-zinc-800 bg-ink-900 p-3" data-testid="galeri-lightbox">
          {active && (
            <div>
              <img src={active.foto} alt={active.judul} className="max-h-[78vh] w-full rounded-xl object-contain" />
              <p className="p-3 text-center text-sm text-navy/80">{active.judul}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
}
